import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { Trans, useTranslator } from 'tradera/lang/translate';

const Render = ({ message }) => (
    <p className="text-left text-danger mb-0">{message}</p>
);

const ServerErrorMessage = ({ serverErrorCode }) => {
    const { t } = useTranslator();

    const mapping = {
        ALIAS_IN_USE: () => t('registration_validation_alias_in_use'),
        ALIAS_CONTAINS_RESERVED_WORD: () =>
            t('registration_validation_alias_contains_reserved_word'),
        APPLE_ID_IN_USE: () => t('registration_validation_apple_id_in_use'),
        EMAIL_IN_USE: () => (
            <Trans
                i18nKey="registration_validation_email_in_use_Trans"
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                components={{ a: <a /> }}
            />
        ),
        FACEBOOK_ID_IN_USE: () =>
            t('registration_validation_facebook_id_in_use'),
        GOOGLE_ID_IN_USE: () => t('registration_validation_google_id_in_use'),
        KLARNA_ID_IN_USE: () => t('registration_validation_klarna_id_in_use'),
        INVALID_ALIAS: () => t('registration_validation_invalid_alias'),
        INVALID_CHARACTERS: () =>
            t('registration_validation_invalid_characters'),
        INVALID_COMPANYNAME: () =>
            t('registration_validation_invalid_companyname'),
        INVALID_DATE_OF_BIRTH: () =>
            t('registration_validation_invalid_date_of_birth'),
        INVALID_EMAIL: () => t('registration_validation_invalid_email'),
        INVALID_FIRSTNAME: () => t('registration_validation_invalid_firstname'),
        INVALID_LASTNAME: () => t('registration_validation_invalid_lastname'),
        INVALID_LENGTH_ALIAS: () =>
            t('registration_validation_invalid_length_alias'),
        INVALID_LENGTH_COMPANYNAME: () =>
            t('registration_validation_invalid_length_companyname'),
        INVALID_LENGTH_EMAIL: () =>
            t('registration_validation_invalid_length_email'),
        INVALID_LENGTH_FIRSTNAME: () =>
            t('registration_validation_invalid_length_firstname'),
        INVALID_LENGTH_LASTNAME: () =>
            t('registration_validation_invalid_length_lastname'),
        INVALID_LENGTH_STREETNAME: () =>
            t('registration_validation_invalid_length_streetname'),
        INVALID_LENGTH_TOWN: () =>
            t('registration_validation_invalid_length_town'),
        INVALID_ORGANIZATIONNUMBER: () =>
            t('registration_validation_invalid_organizationnumber'),
        INVALID_PERSONALID: () =>
            t('registration_validation_invalid_personalid'),
        INVALID_PHONENUMBER: () =>
            t('registration_validation_invalid_phonenumber'),
        INVALID_STREETNAME: () =>
            t('registration_validation_invalid_streetname'),
        INVALID_TOWN: () => t('registration_validation_invalid_town'),
        INVALID_ZIPCODE: () => t('registration_validation_invalid_zipcode'),
        ORGANIZATION_NUMBER_IN_USE: () =>
            t('registration_validation_organization_number_in_use'),
        PAYPAL_NOT_VERIFIED: () => (
            <Trans
                i18nKey="registration_validation_paypal_not_verified_Trans"
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                components={{ a: <a /> }}
            />
        ),
        PERSONALID_IN_USE: () => (
            <Trans
                i18nKey="registration_validation_personalid_in_use_Trans"
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                components={{ a: <a /> }}
            />
        ),
        PERSONAL_NUMBER_UNDER_AGE: () =>
            t('registration_validation_personal_number_under_age'),
        UNDER_AGE_INTERNATIONAL: () =>
            t('registration_validation_applicant_under_aged_int'),
        REQUIRED_ALIAS: () => t('registration_validation_required_alias'),
        REQUIRED_COMPANYNAME: () =>
            t('registration_validation_required_companyname'),
        REQUIRED_COUNTRY: () => t('registration_validation_required_country'),
        REQUIRED_EMAIL: () => t('registration_validation_required_email'),
        REQUIRED_FIELD: () => t('registration_validation_required_field'),
        REQUIRED_FIRSTNAME: () =>
            t('registration_validation_required_firstname'),
        REQUIRED_LASTNAME: () => t('registration_validation_required_lastname'),
        REQUIRED_ORGANIZATIONUMBER: () =>
            t('registration_validation_required_organizationumber'),
        REQUIRED_PERSONALID: () =>
            t('registration_validation_required_personalid'),
        REQUIRED_PHONENUMBER: () =>
            t('registration_validation_required_phonenumber'),
        REQUIRED_STREETNAME: () =>
            t('registration_validation_required_streetname'),
        REQUIRED_TOWN: () => t('registration_validation_required_town'),
        REQUIRED_ZIPCODE: () => t('registration_validation_required_zipcode'),
        REQUIRED_TERMS: () => t('registration_validation_required_terms')
    };

    const child = mapping[serverErrorCode] && mapping[serverErrorCode]();

    return child ? <Render message={child} /> : null;
};

export const FormError = ({ errors, serverErrors, name }) => {
    return (
        <>
            <ErrorMessage errors={errors} name={name} render={Render} />
            <ServerErrorMessage serverErrorCode={serverErrors[name]} />
        </>
    );
};
